



























import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
@Component({
    name: 'form-navigation-buttons',
    components: {},
})
export default class FormNavigationButtons extends Vue {
    @Prop({ default: false })
    firstStep!: boolean;

    previousStep() {
        this.$emit('previousStep');
    }

    validateStep() {
        this.$emit('validateStep');
    }

    reset() {
        this.$emit('reset');
    }
}
